import { render } from "./TaskFilterComponent.vue?vue&type=template&id=ab8e936c"
import script from "./TaskFilterComponent.vue?vue&type=script&lang=js"
export * from "./TaskFilterComponent.vue?vue&type=script&lang=js"

import "./TaskFilterComponent.vue?vue&type=style&index=0&id=ab8e936c&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__